module.exports = __webpack_public_path__ + "static/media/Gilroy-Heavy-Italic.c74941f0.woff2";